import { combineReducers } from 'redux';
import create from './create';
import show from './show';

export default combineReducers({ create, show });
